import { Box } from "@mui/material";
import { Outlet, useMatches } from "react-router-dom";
import ToolHeader from "./header/ToolHeader";

const ToolLayout = () => {
  const matches = useMatches();

  const matchWithTitle = [...matches]
    .reverse()
    .find(
      (match) =>
        match.data && typeof match.data === "object" && "title" in match.data
    );

  const title = (matchWithTitle?.data as { title?: string })?.title ?? "Tool";

  return (
    <>
      <ToolHeader title={title} />
      <Box component="main" sx={{ p: 3 }}>
        <Outlet />
      </Box>
    </>
  );
};

export default ToolLayout;
